import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import globalComponents from '../globals/components'
import globalMixins from '../globals/mixins'
import globalStyles from '../globals/styles'

Vue.use(globalComponents)
Vue.use(globalMixins)
Vue.use(globalStyles)
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        gmBlack: '#0a0a0a',
        gmBlue: '#1F8297',
        gmDarkblue: '#003940',
        gmGreen: '#357133',
        gmWhitish: '#F6F5F1',
        gmYellow: '#CB9703',
        error: '#ff6363',
        info: '#64b6f7',
        success: '#5eb762',
        warning: '#ffe083'
      }
    }
  }
})
